<template>
    <div>
        <nav-breadcrumb :menu="[{label :'用款申请'}]"/>
        <el-form label-width="170px" class="xzformitemmb" :model="financingDetail" ref="dataForm">
            <el-row>
                <panel title="贷款信息" border>
                    <el-col :span="12">
                        <el-form-item label="贷款编号 ：">
                            {{financingDetail.fi__transactionNo}}

                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="贷款状态：">
                            {{'Financing_'+ financingDetail.fi__transactionStatus|Status2CN}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户名称：">
                            {{financingDetail.fi__customerName}}&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="primary"
                                                                                                   size="mini"
                                                                                                   @click="showDialog">
                            业务审查表
                        </el-button>
                        </el-form-item>
                        <el-form-item label="贷款金额：">
                            {{financingDetail.fi__totalAmount|formatMoney}} 元
                        </el-form-item>
                        <el-form-item label="贷款开始日期：">
                            {{financingDetail.fi__startDate|moment('YYYY-MM-DD')}}
                        </el-form-item>
                        <el-form-item label="贷款合同利率：">
                            {{financingDetail.fi__interestRate|formatMoney}}%
                            （{{financingDetail.fi__interestType|Status2CN}}）
                        </el-form-item>
                        <el-form-item label="贷款合同月利率：">
                            {{financingDetail.monthRate}}‰
                        </el-form-item>

                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="渠道商：">
                            {{financingDetail.d__dealerName}}
                        </el-form-item>
                        <el-form-item label="贷款产品：">
                            {{financingDetail.ct__productName}}
                        </el-form-item>

                        <el-form-item label="贷款结束日期：">
                            {{financingDetail.fi__endDate|moment('YYYY-MM-DD')}}
                        </el-form-item>

                        <el-form-item label="留存收益率：">
                            {{financingDetail.dfi__interestRate|formatMoney}}%
                            （{{financingDetail.dfi__interestType|Status2CN}}）
                        </el-form-item>
                        <el-form-item label="还款期数（月）：">
                            {{financingDetail.fi__repaymentCount}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="还款方式：">
                            {{financingDetail.fi__repaymentFormula|Status2CN}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="贷款用途：">
                            {{financingDetail.fi__intendedUse}}
                        </el-form-item>
                    </el-col>
                </panel>
                <panel label="房屋信息">
                    <panel :label="'抵押物'+(idx+1)"  v-for="(item, idx) in financingDetail.properties" :key="idx" >
                        <form-build
                            :form-data="item"
                            :form-rules="financingRules"
                            :form-columns="houseColumns"
                            class="formTable"
                        />
                        <br/>
                        <div class="zhenjianyyzz zhenjianyyzz2">
                            <photo-browser v-model="item.doc__hisWarrant" type='image' label="他项权证"/>
                        </div>
                    </panel>
                </panel>
                <panel title="放款信息" border>
                    <el-col :span="12">
                        <el-form-item label="收款账号：">
                            {{financingDetail.pay__customerAccountNo}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="户名：">
                            {{financingDetail.pay__customerAccountName}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="开户行：">
                            {{financingDetail.pay__customerAccountBankName}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="financingDetail.pay__nodeType!='CWFH'">
                        <el-form-item label="放款方式：" prop="pay__channel">
                            {{financingDetail.pay__channel|Status2CN}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="financingDetail.pay__nodeType=='CWFH'">
                        <el-form-item label="放款方式：" prop="pay__channel" :rules="{required: true, message: '放款方式不能为空'}"
                                      style="width: 60%">
                            <el-select placeholder="请选择放款方式" v-model.trim="financingDetail.pay__channel" >
                                <el-option label="通联支付" value="TLT"></el-option>
                                <el-option label="网银转账" value="BANKTRANSFER"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="申请放款金额：">
                            {{financingDetail.pay__totalAmount|formatMoney}} 元
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="申请放款日期：">
                            {{financingDetail.pay__paymentDate|moment('YYYY-MM-DD')}}
                        </el-form-item>
                        <!-- <el-form-item label="申请放款日期：" prop="pay__paymentDate" :rules="{required: true, message: '日期不能为空'}" >
                           <el-date-picker
                             v-model="financingDetail.pay__paymentDate"
                             value-format="yyyy-MM-dd"
                             format="yyyy-MM-dd"
                             type="date"
                             placeholder="选择日期">
                           </el-date-picker>
                         </el-form-item>-->
                    </el-col>
                </panel>
            <!--  <panel class="zhengjianxinxi">
                <photo-browser v-model="financingDetail.pic__customerBankCardFront" type='image' label="银行卡正面"/>
              </panel>-->
                <panel label="相关材料" class="zhengjianxinxi">
                    <photo-browser v-model="financingDetail.fidoc__dealerLetter" type='image' label="渠道推荐函"/>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload v-model="financingDetail.fidoc__signedContract" :editable="false"></file-upload>
                        签约后的借款合同
                    </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload v-model="financingDetail.fidoc__pledgeExContract" :editable="false"></file-upload>
                        一抵信息
                    </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload v-model="financingDetail.fidoc__pledgeContract" :editable="false"></file-upload>
                        抵押合同
                    </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload v-model="financingDetail.fidoc__otherDoc" :editable="false"></file-upload>
                        其他
                    </div>
                    <el-button type="primary" size="mini" class="btn-print" @click="print">一键打印</el-button>
                </panel>
                <panel border>
                    <el-col :span="24">
                        <el-form-item label="备注：">
                            <el-input type="textarea" v-model="financingDetail.pay__remarks" style="margin-bottom:10px;"
                                      disabled></el-input>
                        </el-form-item>
                    </el-col>
                </panel>
                <panel label="材料核实结果" border v-if="financingDetail.pay__nodeType!='YWFZR'&&financingDetail.pay__nodeType!='CWCS'">
                    <el-col :span="24">
                        <el-checkbox false-label="N" true-label="Y" v-model="financingDetail.pay__documentChecked"
                                     :disabled="financingDetail.pay__nodeType!='FKSH'">本次放款所需材料已核实
                        </el-checkbox>
                    </el-col>
                </panel>
                <panel label="保证金信息" border v-if="financingDetail.pay__nodeType!='YWFZR'">
                    <el-col :span="24">
                        <el-checkbox false-label="N" true-label="Y" v-model="financingDetail.pay__depositChecked"
                                     :disabled="financingDetail.pay__nodeType!='CWCS'">本次放款所需保证金充足<span v-if="financingDetail.pay__creditBalance">，保证金可贷余额：{{financingDetail.pay__creditBalance|formatMoney}}元（不含本笔）。</span>
                        </el-checkbox>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="保证金使用说明：" prop="pay__depositRemarks"
                                      :rules="{required: true, message: '保证金使用说明不能为空'}">
                            <el-input type="textarea" v-model="financingDetail.pay__depositRemarks"
                                      style="margin-bottom:10px;"
                                      :disabled="financingDetail.pay__nodeType!='CWCS'"></el-input>
                        </el-form-item>
                    </el-col>
                </panel>

                <panel label="">
                    <el-row>
                        <el-col class="grid-content bg-purple">
                            <el-tabs v-model="tabName">
                                <template>
                                    <el-tab-pane label="审核流程" name="tabName1">
                                        <data-table
                                            :table-data="approvalArry"
                                            :columns="tableColumns"
                                            :is-pagination-show="false"
                                        />
                                    </el-tab-pane>
                                    <el-tab-pane label="流程图" name="tabName2">
                                        <img
                                            src="../../assets/images/YK.png"  style="width: 100%"></img>
                                    </el-tab-pane>
                                </template>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </panel>

                <panel border>
                    <el-col :span="24">
                        <el-form-item label="审核意见：">
                            <el-input type="textarea" v-model="financingDetail.a__remarks"
                                      style="margin-bottom:10px;"></el-input>
                        </el-form-item>
                    </el-col>
                </panel>
            </el-row>
        </el-form>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('dataForm','Approved')">审核通过</el-button>
            <el-button @click="onSubmit('dataForm','Rejected')">否决</el-button>
        </div>
        <el-dialog :visible.sync="dialogVisible" title="客户详情" width="70%">
            <customer-view :application-id="financingDetail.fi__referenceId"></customer-view>
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import moment from 'moment'
    import Status2CN from "../../filters/Status2CN";
    import CustomerView from "../dealer/CustomerView";
    import {formatMoney} from "../../filters/CommonFilters";
    import Panel from "../../components/Panel";

    export default {
        name: "LoanApproved",
        components: {Panel, CustomerView},
        data() {
            return {
                tabName:'tabName1',
                financingRules:{
                },
                houseColumns:[
                    {
                        label: '抵押房产',
                        field: 'pr__propertyLocation',

                    },
                    {
                        label: '他项权证号',
                        field: 'doc__hisWarrantNo',

                    },
                ],
                dialogVisible: false,
                role: this.$route.query['role'] || '',
                financingDetail: {
                    monthRate: '',
                },
                tableColumns: [
                    {
                        label: '节点',
                        field: 'node',
                        formatter: function (r, c, v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '操作人',
                        field: 'approverName'
                    },
                    {
                        label: '操作时间',
                        field: 'time',
                        formatter: function (r, c, v) {
                            return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
                        }
                    },
                    {
                        label: '操作结果',
                        field: 'status'
                    }, {
                        label: '操作备注',
                        field: 'remarks'
                    },

                ],
                approvalArry: {
                    data: [],
                    count: 0,
                },
                approvalListcount: 0,
                approvalList: {},
            }
        },
        filters: {

            Status2CN
        },
        mounted() {
            this.getData()
        },
        methods: {
            showDialog: function () {
                window.open('/ix/fang/financing/ReviewForm.jasper?applicationId=' + this.financingDetail.fi__referenceId)
            },
            print: function () {
                xhr.docs({
                    'transactionId': this.financingDetail.fi__transactionId,
                    'alpha': 0.5,
                    resizable: true
                }, res => {
                    try {
                        if (res.data.status == 'success') {
                            let routeData = this.$router.resolve({
                                path: '/files/' + res.data.path + '/!/?contentType=application/pdf',
                                query: Object.assign(
                                    {},
                                    {}, {})
                            });
                            window.open(routeData.href.replace('#/', '/'), '_blank');
                        }
                        else if (res.data.status == 'pending'){
                          this.print()
                        } else {
                            this.$message.error('对不起，服务器生成失败！')
                        }
                    } catch (e) {
                    }
                })

            },
            setApproval: function () {
                let count = 2
                this.approvalArry.data.push(
                    {
                        node: '项目申请人',
                        approverName: this.financingDetail.createdBy__userName,
                        time: this.financingDetail.pay__createdDate,
                        status: '提交成功',
                        remarks: '',

                    }
                )
                console.log(this.approvalList)
                for (var i = 0; i < this.approvalList.length; i++) {
                    if (this.approvalList[i].a__approvalType) {
                        this.approvalArry.data.push(
                            {
                                node: this.approvalList[i].a__nodeName,
                                approverName: this.approvalList[i].a__approverName,
                                time: this.approvalList[i].a__approvingDate,
                                status: Status2CN(this.approvalList[i].a__approvingStatus),
                                remarks: this.approvalList[i].a__remarks,

                            }
                        )
                        count++
                    }


                }
                this.approvalArry.count = count
            },
            getData: function () {
                xhr.getViewFinancingPaymentForApproval({
                        'pay.applicationId': this.$route.query['applicationId']
                    },
                    res => {
                        try {
                            if (res.data.status == 'success') {
                                this.financingDetail = res.data.data
                                this.approvalList = res.data.data.approvals
                                this.setApproval()
                                if (this.financingDetail.ct__interestType == 'Yearly') {
                                    this.financingDetail.monthRate = (this.financingDetail.fi__interestRate / 12)
                                }
                                if (this.financingDetail.ct__interestType == 'Monthly') {
                                    this.financingDetail.monthRate = this.financingDetail.fi__interestRate
                                }
                                if (this.financingDetail.ct__interestType == 'Daily') {
                                    this.financingDetail.monthRate = (this.financingDetail.fi__interestRate * 30)
                                }
                                this.financingDetail.monthRate =parseFloat( (parseFloat(this.financingDetail.monthRate) * 10).toFixed(3))
                            }
                        } catch (e) {

                        }
                    })
            },
            onSubmit: function (formName, status) {
                this.$refs[formName].validate(valid => {
                    if (status == 'Rejected' || valid) {
                        if (this.financingDetail.pay__documentChecked != 'Y' && this.financingDetail.pay__nodeType == 'FKSH' && status != 'Rejected') {
                            this.$alert('请确认放款所需材料已核实')
                            return false
                        }
                        if (this.financingDetail.pay__depositChecked != 'Y' && this.financingDetail.pay__nodeType == 'CWCS' && status != 'Rejected') {
                            this.$alert('请确认本次放款所需保证金充足')
                            return false
                        }
                        if(this.financingDetail.pay__nodeType == 'CWCS'){
                          if(this.financingDetail.pay__totalAmount>this.financingDetail.pay__creditBalance&&this.financingDetail.pay__creditBalance !=null){
                            this.$alert('保证金对应可贷金额不足')
                            return false
                          }
                        }

                        let onSubmitFrom = {}


                        onSubmitFrom.pay__applicationId = this.financingDetail.pay__applicationId
                        onSubmitFrom.pay__documentChecked = this.financingDetail.pay__documentChecked
                        onSubmitFrom.a__remarks = this.financingDetail.a__remarks
                        onSubmitFrom.pay__depositChecked = this.financingDetail.pay__depositChecked
                        onSubmitFrom.pay__depositRemarks = this.financingDetail.pay__depositRemarks
                        //onSubmitFrom.fidoc__hisWarrantNo = this.financingDetail.fidoc__hisWarrantNo
                        onSubmitFrom.pay__channel = this.financingDetail.pay__channel
                        if(this.financingDetail.pay__nodeType == 'CWCS'){
                          onSubmitFrom.pay__depositBalance = this.financingDetail.pay__depositBalance
                          onSubmitFrom.pay__creditBalance = this.financingDetail.pay__creditBalance
                        }
                        onSubmitFrom.a__approvingStatus = status
                        xhr.createApproveFinancingPayment(onSubmitFrom, res => {
                            try {
                                if (res.data.status == 'success') {

                                    this.$router.push({
                                        path: 'List'
                                    })
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/LoanApproved.vue